module.exports = __webpack_public_path__ + "media/images/cruze-logo-small-white-1cee8105a39cb7968b6818cb2ab6d911.png";